'use client';

import { createContext, useContext } from 'react';

import type { PhaserProps } from './types';
import type { FC, PropsWithChildren } from 'react';

const PhaserContext = createContext<PhaserProps | undefined>(undefined);

export const PhaserProvider: FC<
  PropsWithChildren<{ phaser?: PhaserProps }>
> = ({ children, phaser }) => {
  return (
    <PhaserContext.Provider value={phaser}>{children}</PhaserContext.Provider>
  );
};

// eslint-disable-next-line react-refresh/only-export-components -- hook co-located with its context provider
export const usePhaser = () => {
  return useContext(PhaserContext);
};
